import React, { useCallback } from 'react';
import PropTypes from 'prop-types';

import makeStyles from '@mui/styles/makeStyles';
import Box from '@mui/material/Box';
import IconButton from '@mui/material/IconButton';

import ArrowDropDown from '@mui/icons-material/ArrowDropDown';
import ArrowDropUp from '@mui/icons-material/ArrowDropUp';

import Typography from '@ts-core/components/Typography';

const useStyles = makeStyles((theme) => ({
  scoreLabel: {
    marginTop: -theme.spacing(1.5),
    marginBottom: -theme.spacing(1.5),
  },
  upvoteButton: {
    marginTop: theme.spacing(-1),
  },
}));

const ForumItemScore = (props) => {
  const classes = useStyles();
  const { item, score, onDownvote, onUpvote, canUpvote, canDownvote } = props;

  const handleUpvote = useCallback(() => {
    onUpvote(item);
  }, [onUpvote, item]);

  const handleDownvote = useCallback(() => {
    onDownvote(item);
  }, [onDownvote, item]);

  return (
    <Box display="flex" flexDirection="column" alignItems="center">
      <IconButton
        size="small"
        onClick={handleUpvote}
        disabled={!canUpvote}
        className={classes.upvoteButton}
      >
        <ArrowDropUp fontSize="large" />
      </IconButton>
      <Typography variant="h6" className={classes.scoreLabel}>
        {score}
      </Typography>
      <IconButton size="small" onClick={handleDownvote} disabled={!canDownvote}>
        <ArrowDropDown fontSize="large" />
      </IconButton>
    </Box>
  );
};

ForumItemScore.propTypes = {
  item: PropTypes.object,
  score: PropTypes.number,
  onUpvote: PropTypes.func,
  onDownvote: PropTypes.func,

  canUpvote: PropTypes.bool,
  canDownvote: PropTypes.bool,
};

ForumItemScore.defaultProps = {
  item: {},
  score: undefined,
  canUpvote: true,
  canDownvote: true,
  onUpvote() {},
  onDownvote() {},
};

export default ForumItemScore;
